/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from 'components/SolidButton';

import './alert-modal.scss';

const AlertModal = ({
  open,
  onCancelAction,
  onConfirmAction,
  title,
  description,
  labelConfirm,
  customAlertModal,
  category,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="alert-modal__overlay" onClick={onCancelAction}>
      <div className="alert-modal__content" onClick={(event) => event.stopPropagation()}>
        <h3 className="modal__title">{title}</h3>
        <p className="modal__subtitle">{description}</p>
        <div className="d-flex justify-content-center">
          {!customAlertModal && (
            <Button className="evie-secondary mr-2" onClick={onCancelAction}>
              {t('button.cancel')}
            </Button>
          )}
          <Button onClick={onConfirmAction} className={category}>
            {labelConfirm}
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

AlertModal.defaultProps = {
  customAlertModal: false,
  category: '',
};

AlertModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancelAction: PropTypes.func.isRequired,
  onConfirmAction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  labelConfirm: PropTypes.string.isRequired,
  customAlertModal: PropTypes.bool,
  category: PropTypes.string,
};

export default AlertModal;
